var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Arrow Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.1665 13.6667C12.4427 13.6666 12.6667 13.8904 12.6667 14.1666C12.6667 14.4427 12.443 14.6666 12.1668 14.6667L3.50014 14.6692C3.224 14.6693 3 14.4455 3 14.1694C3 13.8932 3.22371 13.6693 3.49986 13.6692L12.1665 13.6667ZM7.76549 1.34123L7.83333 1.33667C8.08646 1.33667 8.29566 1.52477 8.32877 1.76882L8.33333 1.83667L8.33267 10.96L10.8139 8.47978C10.9914 8.30229 11.2692 8.28618 11.4649 8.43144L11.521 8.47986C11.6985 8.65739 11.7146 8.93516 11.5693 9.13089L11.5209 9.18696L8.18915 12.518C8.01172 12.6954 7.73413 12.7116 7.5384 12.5666L7.48232 12.5182L4.14669 9.18717C3.95129 8.99204 3.95108 8.67546 4.14621 8.48006C4.3236 8.30243 4.60136 8.2861 4.7972 8.4312L4.85331 8.47958L7.33267 10.9553L7.33333 1.83667C7.33333 1.58354 7.52144 1.37434 7.76549 1.34123L7.83333 1.33667L7.76549 1.34123Z",
    fill: "#0B3E91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadBlue);
export default __webpack_public_path__ + "static/media/icon-download-blue.3ab7aa879b7bff9bd02084dfe6b70f41.svg";
export { ForwardRef as ReactComponent };